import {AmexCard} from "@/schemas/creditCard/brands/AmexCard";
import {CreditCardEnum} from "@/schemas/creditCard/CreditCard.enum";
import {CredCard} from "@/schemas/creditCard/brands/CredCard";
import {VisaCard} from "@/schemas/creditCard/brands/VisaCard";
import {HiperCard} from "@/schemas/creditCard/brands/HiperCard";
import {DinnersCard} from "@/schemas/creditCard/brands/DinnersCard";
import {EloCard} from "@/schemas/creditCard/brands/EloCard";

export class CreditCard {
    private _card: string;

    constructor(card: string) {
        this._card = card.replace(/\D+/g, "");
    }

    validateNumber(): boolean {
        return /\d{13,19}/.test(this._card)
    }

    getBrand() : CreditCardEnum {
        if (!this.validateNumber()) {
            return CreditCardEnum.DESCONHECIDO
        } else if (AmexCard.isBrandAmex(this._card)) {
            return CreditCardEnum.AMEX
        } else if (EloCard.isElo(this._card)) {
            return CreditCardEnum.ELO
        } else if (CredCard.isMasterCard(this._card)) {
            return CreditCardEnum.MASTERCARD
        } else  if (VisaCard.isVisa(this._card)) {
            return CreditCardEnum.VISA
        } else if (HiperCard.isHiperCard(this._card)) {
            return CreditCardEnum.HIPERCARD
        } else if (DinnersCard.isDinners(this._card)) {
            return CreditCardEnum.DINNERS
        } else {
            return CreditCardEnum.DESCONHECIDO
        }
    }

    isValid(): boolean {
        return CreditCardEnum.DESCONHECIDO !== this.getBrand()
    }

}